(function judgeDateForceFixPersistent(){
  console.info('[judge-date-fix] persistent fixer loaded');

  function pad(n){ return String(n).padStart(2,'0'); }
  function formatDDDotMMDotYYYY(d){
    return `${pad(d.getUTCDate())}.${pad(d.getUTCMonth()+1)}.${d.getUTCFullYear()}`;
  }
  function parseDataContentToDate(s){
    if(!s) return null;
    const part = String(s).trim().split('T')[0].split(' ')[0];
    if(/^\d{4}-\d{1,2}-\d{1,2}$/.test(part)){
      const [y,m,d] = part.split('-').map(Number);
      return new Date(Date.UTC(y, m-1, d));
    }
    const parsed = Date.parse(s);
    return isNaN(parsed) ? null : new Date(parsed);
  }

  function formatFromDataContent(dc){
    const dt = parseDataContentToDate(dc);
    if(!dt) return null;
    return formatDDDotMMDotYYYY(dt);
  }

  function forceSetText(el, text){
    try {
      // Replace all text nodes inside the element to avoid frameworks re-inserting nodes
      while(el.firstChild) el.removeChild(el.firstChild);
      el.appendChild(document.createTextNode(text));
      el.dataset.jdfFixed = '1';
      return true;
    } catch(e){
      try { el.textContent = text; el.dataset.jdfFixed = '1'; return true; } catch(e2) { return false; }
    }
  }

  function fixOne(el){
    if(!el) return false;
    // always read data-content (Judge.me uses this)
    const dc = el.getAttribute('data-content') || el.dataset.content;
    const formatted = formatFromDataContent(dc);
    if(!formatted) return false;
    // if already correct, still re-apply to ensure persistence
    forceSetText(el, formatted);
    // console.info('[judge-date-fix] applied', dc, '->', formatted, el);
    return true;
  }

  // Observe a single timestamp node for future changes and reapply format
  function watchTimestampNode(el){
    if(!el || el._jdf_watching) return;
    el._jdf_watching = true;

    // initial fix
    fixOne(el);

    // watch changes to its children/text
    const obs = new MutationObserver((mutations) => {
      // If data-content attribute changed or child text changed, re-apply formatted text
      let shouldFix = false;
      for(const m of mutations){
        if(m.type === 'attributes' && (m.attributeName === 'data-content' || m.attributeName === 'data-content')) {
          shouldFix = true;
          break;
        }
        if(m.type === 'characterData' || m.type === 'childList') {
          shouldFix = true;
          break;
        }
      }
      if(shouldFix) {
        // small microtask delay helps when frameworks quickly re-render
        setTimeout(()=> {
          fixOne(el);
        }, 20);
      }
    });

    obs.observe(el, { childList: true, subtree: true, characterData: true, attributes: true });

    // also re-apply if attribute data-content itself is changed
    // store observer so we can disconnect later if needed
    el._jdf_observer = obs;
  }

  // Process all existing timestamps
  function processAll(root){
    const nodes = (root || document).querySelectorAll('span.jdgm-rev__timestamp[data-content]');
    nodes.forEach(n => watchTimestampNode(n));
    return nodes.length;
  }

  // Top-level observer: watch for new timestamp spans added to DOM and watch them
  const topObserver = new MutationObserver((mutations) => {
    for(const m of mutations){
      if(m.type === 'childList' && m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(node => {
          if(node.nodeType !== 1) return;
          // if the added node itself is a timestamp
          if(node.matches && node.matches('span.jdgm-rev__timestamp[data-content]')) {
            watchTimestampNode(node);
            return;
          }
          // otherwise, look inside it for timestamp spans
          const found = node.querySelector && node.querySelectorAll && node.querySelectorAll('span.jdgm-rev__timestamp[data-content]');
          if(found && found.length){
            found.forEach(n => watchTimestampNode(n));
          }
        });
      }
      // Also if attributes of existing nodes changed to add data-content later:
      if(m.type === 'attributes' && m.target && m.target.matches && m.target.matches('span.jdgm-rev__timestamp')) {
        watchTimestampNode(m.target);
      }
    }
  });

  try {
    topObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-content'] });
    // console.info('[judge-date-fix] top-level MutationObserver attached');
  } catch(e){
    // console.warn('[judge-date-fix] top-level observer failed', e);
  }

  // initial run
  const initial = processAll(document);
  // console.info('[judge-date-fix] initial watch count:', initial);

  // polling fallback (short-lived)
  let attempts = 0;
  const maxAttempts = 50; // ~25s if interval 500ms
  const poll = setInterval(() => {
    attempts++;
    const count = processAll(document);
    if(count && attempts === 1) console.info('[judge-date-fix] poll applied to', count, 'nodes');
    if(attempts >= maxAttempts) {
      clearInterval(poll);
      // console.info('[judge-date-fix] poll stopped after attempts', attempts);
    }
  }, 500);

  // helper for console re-run
  window.judgeDateForceFix = function(){ return processAll(document); };

})();